import type { JSX } from "react";

import { Tooltip as BaseTooltip } from "@base-ui/react/tooltip";

import type { TooltipProviderProps } from "./Tooltip.types";

export function TooltipProvider({
  ...props
}: TooltipProviderProps): JSX.Element {
  return <BaseTooltip.Provider data-slot="tooltip-provider" {...props} />;
}
